import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

const transactions = [
  { id: 1, name: "Animal World", date: "06/01/2026", amount: -103.68, icon: "paw" },
  { id: 2, name: "Electricity Bill", date: "06/01/2026", amount: -96.00, icon: "bill" },
  { id: 3, name: "Bus", date: "06/01/2026", amount: -48.00, icon: "bus" },
  { id: 4, name: "Animal World", date: "06/01/2026", amount: -75.00, icon: "paw" },
];

const TransactionIcon = ({ type, color }) => {
  switch (type) {
    case "paw":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7" cy="8" r="2" fill={color} />
          <circle cx="12" cy="6" r="2" fill={color} />
          <circle cx="17" cy="8" r="2" fill={color} />
          <circle cx="6" cy="14" r="2" fill={color} />
          <circle cx="18" cy="14" r="2" fill={color} />
          <ellipse cx="12" cy="16" rx="4" ry="3" fill={color} />
        </svg>
      );
    case "bill":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="3" width="16" height="18" rx="2" stroke={color} strokeWidth="2" />
          <path d="M8 8h8M8 12h8M8 16h4" stroke={color} strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "bus":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="4" width="16" height="14" rx="2" stroke={color} strokeWidth="2" />
          <path d="M4 10h16" stroke={color} strokeWidth="2" />
          <circle cx="8" cy="15" r="1.5" fill={color} />
          <circle cx="16" cy="15" r="1.5" fill={color} />
          <path d="M7 4V2M17 4V2" stroke={color} strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    default:
      return null;
  }
};

export const RegionalCardDetail = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    const currentParams = location.search;
    navigate(`/regional-landing-corporativo-mobile${currentParams}`);
  };

  return (
    <div className="regional-card-detail">
      <div className="regional-card-detail-container">
        {/* Dot Pattern Background */}
        <div className="card-detail-dot-pattern">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(8)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.1 + (row * 0.05) + (col * 0.03);
                return (
                  <circle
                    key={`${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.secundario}
                    fillOpacity={Math.min(opacity, 0.8)}
                  />
                );
              })
            )}
          </svg>
        </div>

        {/* Header */}
        <div className="card-detail-header">
          <div className="back-button" onClick={handleBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke={colors.primario} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {/* Title */}
        <div className="card-detail-title" style={{ color: colors.primario }}>
          Card details
        </div>

        {/* Credit Card */}
        {colors.url_card ? (
          <div className="card-detail-card-image-wrapper">
            <img src={colors.url_card} alt="Credit Card" className="card-detail-card-image" />
          </div>
        ) : (
          <div className="card-detail-card" style={{ background: 'linear-gradient(135deg, #D4A574 0%, #C9956C 100%)' }}>
            <div className="card-brand">VISA</div>
            <div className="card-type-info">
              <span className="card-type-label">Credit Card</span>
              <span className="card-number">**** **** **** 9160</span>
            </div>
            <div className="card-balance-section">
              <span className="balance-label">Balance</span>
              <span className="balance-value">$ 5.93</span>
            </div>
            <div className="card-expiry-section">
              <span className="expiry-label">Expiration date</span>
              <span className="expiry-value">04/2028</span>
            </div>
          </div>
        )}

        {/* Quick Actions */}
        <div className="card-detail-actions">
          <div className="action-item">
            <div className="action-icon" style={{ backgroundColor: colors.primario }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="8" stroke="white" strokeWidth="2" />
                <path d="M12 8v8M8 12h8" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <span className="action-label">CVV</span>
          </div>
          <div className="action-item">
            <div className="action-icon" style={{ backgroundColor: colors.primario }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="10" width="12" height="10" rx="2" stroke="white" strokeWidth="2" />
                <path d="M8 10V7a4 4 0 118 0v3" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </div>
            <span className="action-label">PIN</span>
          </div>
          <div className="action-item">
            <div className="action-icon" style={{ backgroundColor: colors.primario }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 19V5M12 5l-5 5M12 5l5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="action-label">Deposit</span>
          </div>
          <div className="action-item">
            <div className="action-icon" style={{ backgroundColor: colors.primario }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5v14M12 19l-5-5M12 19l5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="action-label">Withdraw</span>
          </div>
        </div>

        {/* Transactions Section */}
        <div className="card-detail-transactions">
          <h2 className="transactions-title">Transactions</h2>
          <div className="transactions-list">
            {transactions.map((transaction) => (
              <div key={transaction.id} className="transaction-item">
                <div className="transaction-icon" style={{ backgroundColor: `${colors.primario}15` }}>
                  <TransactionIcon type={transaction.icon} color={colors.primario} />
                </div>
                <div className="transaction-info">
                  <span className="transaction-name">{transaction.name}</span>
                  <span className="transaction-date">{transaction.date}</span>
                </div>
                <span className="transaction-amount">
                  -${Math.abs(transaction.amount).toFixed(2)}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Dot Pattern */}
        <div className="card-detail-dot-pattern-bottom">
          <svg width="200" height="100" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            {[...Array(4)].map((_, row) =>
              [...Array(8)].map((_, col) => {
                const opacity = 0.3 - (row * 0.05);
                return (
                  <circle
                    key={`bottom-${row}-${col}`}
                    cx={20 + col * 25}
                    cy={20 + row * 25}
                    r="3"
                    fill={colors.primario}
                    fillOpacity={Math.max(opacity, 0.1)}
                  />
                );
              })
            )}
          </svg>
        </div>
      </div>
    </div>
  );
};
